/** Created by azhou on 2019/3/13.*/
<template>
    <div>
      <public-title>发票列表
        <div slot="right" class="ml-auto">
          <el-button size="small" type="success" @click="addInvoice">添加发票</el-button>
          <span class="text-link ml-4 h6" v-show="isGroup" @click="$router.back()">返回列表</span>
        </div>
      </public-title>
      <div class="load-area">
        <p v-if="StoreInvoiceLists.total<=0">当前没有数据</p>
        <div v-else>
          <!-- <ul class="list-head"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul> -->
          <el-row>
            <el-col :span="12" v-for="Itemize in StoreInvoiceLists.lists" :key="Itemize.id">
              <el-container v-if="!Itemize.rise">
                <el-header class="pr-5">
                  <span class="text-link mr-2" @click="goForDetail(Itemize)">查看</span>
                  <span class="text-link mr-2" @click="goForEdit(Itemize)">编辑</span>
                  <span class="text-link" @click="deleteItem(Itemize)">删除</span>
                </el-header>
                <el-container class="pr-5">
                  <el-aside><div v-for="(item, index) in sideArr" :key="index">{{item}}</div></el-aside>
                  <el-main>
                    <p>专票</p>
                    <p>{{Itemize.corporate_name}}</p>
                    <p>{{Itemize.duty_paragraph}}</p>
                    <p>{{Itemize.address}}</p>
                    <p>{{Itemize.corporate_mobile}}</p>
                    <p>{{Itemize.opening_bank}}</p>
                    <p>{{Itemize.account_number}}</p>
                    <p>{{Itemize.addressee}}</p>
                    <p>{{Itemize.mobile}}</p>
                    <p>
                      <el-popover placement="right" trigger="hover">
                          {{Itemize.receiving_address}}<span slot="reference">{{Itemize.receiving_address | formatString(20)}}</span>
                      </el-popover>
                    </p>
                  </el-main>
                </el-container>
              </el-container>
              <el-container v-else>
                <el-header class="pr-5">
                  <span class="text-link mr-2" @click="goForDetail(Itemize)">查看</span>
                  <span class="text-link mr-2" @click="goForEdit(Itemize)">编辑</span>
                  <span class="text-link" @click="deleteItem(Itemize)">删除</span>
                </el-header>
                <el-container class="pr-5">
                  <el-aside><div v-for="(item, index) in titleArr" :key="index">{{item}}</div></el-aside>
                  <el-main>
                    <p>普票</p>
                    <p>{{Itemize.rise}}</p>
                    <p>{{Itemize.duty_paragraph}}</p>
                    <p>{{Itemize.addressee}}</p>
                    <p>{{Itemize.mobile}}</p>
                    <p>
                      <el-popover placement="right" trigger="hover">
                          {{Itemize.receiving_address}}<span slot="reference">{{Itemize.receiving_address | formatString(20)}}</span>
                      </el-popover>
                    </p>
                  </el-main>
                </el-container>
              </el-container>
            </el-col>
          </el-row>
          <!-- <ul class="list-item" v-for="Itemize in StoreInvoiceLists.lists" :key="Itemize.id">
            <li class="w-50 list-item-col">{{Itemize.rise ? '增值税普通发票' : '增值税专用发票'}}</li>
            <li class="w-50 list-item-col">{{Itemize.rise || '无'}}</li>
            <li class="w-50 list-item-col">{{Itemize.duty_paragraph || '无'}}</li>
            <li class="w-50 list-item-col">{{Itemize.addressee || '无'}}</li>
            <li class="w-50 list-item-col">{{Itemize.mobile || '无'}}</li>
            <li class="w-50 list-item-col-end">
              <span class="text-link mr-2" @click="goForDetail(Itemize)">查看</span>
              <span class="text-link" @click="deleteItem(Itemize)">删除</span>
            </li>
          </ul> -->
          <el-pagination background layout="prev, pager, next" class="mt-4"
                        :total="StoreInvoiceLists.total" :current-page="Number(queryCon.page)"
                        @current-change="v => this.currentPage=v"/>
        </div>
      </div>
      <el-dialog title="发票详情" :visible.sync="showDetail" center>
        <div class="d-center-start mb-3" v-for="item in notEmptyDetail" :key="item.name">
          <left-text :leftText="item.name"/>{{detailItem[item.value]}}
        </div>
        <div class="d-center-start mb-2"><left-text leftText="添加时间"/>{{detailItem.time | formatTimestamp(1)}}</div>
        <el-button type="primary" slot="footer" @click="showDetail = false">确 定</el-button>
      </el-dialog>
    </div>
</template>

<script>
  import { mapGetters, mapActions,mapState,mapMutations } from 'vuex'

  export default {
    name: 'StoreInvoiceLists',
    computed: {
      ...mapState(['StoreInvoiceLists']),
      ...mapGetters(['storeInfo','isGroup']),
      queryCon() { return this.$route.query },
      //查看发票详情时只展示非空项
      notEmptyDetail() {
        let arr = [];
        this.showDetailArr.forEach(v => {
          if (this.detailItem[v.value]) arr.push(v);
        })
        return arr;
      }
    },
    watch:{
      queryCon() { this.getStoreInvoiceLists({...this.queryCon,page:this.currentPage}); },
      currentPage() { this.$router.push({name:this.$route.name,query:{...this.queryCon,page:this.currentPage}}) }
    },
    data() {
      return {
        titleArr:['发票类型','抬头','税号','收件人','联系方式','收件地址'],
        sideArr: ['发票类型','公司名称','税号','发票公司地址','公司电话','开户行名称','开户账号','收件人','联系方式','收件地址'],
        currentPage:1,
        showDetail:false,
        detailItem:{},
        showDetailArr:[
          {name:'公司名称',value:'corporate_name'},
          {name:'抬头',value:'rise'},
          {name:'税号',value:'duty_paragraph'},
          {name:'开户行名称',value:'opening_bank'},
          {name:'开户账号',value:'account_number'},
          {name:'发票公司地址',value:'address'},
          {name:'公司电话',value:'corporate_mobile'},
          {name:'收件人',value:'addressee'},
          {name:'联系方式',value:'mobile'},
          {name:'收件地址',value:'receiving_address'},
        ]
      }
    },
    mounted() {
      this.UPDATECURRENTSTORE({storeId:this.queryCon.store})
      this.getStoreInvoiceLists({page:this.currentPage});
    },
    beforeDestroy() {
      this.UPDATECURRENTSTORE({storeId:''})
    },
    methods:{
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['getStoreInvoiceLists','deleteStoreInvoice']),
      //查看发票
      goForDetail(item) {
        if (!this.$GFUN.powerIsInArray([160,280,375,610])) { this._alert('您没有相关权限！',null,'error'); return; }
        this.showDetail = true;
        this.detailItem = item;
      },
      //编辑发票
      goForEdit(item) {
        if (!this.$GFUN.powerIsInArray([161,281,377,617])) { this._alert('您没有相关权限！',null,'error'); return; }
        this.$router.push({name:'addInvoice',query:{store:this.$route.query.store,item}})
      },
      //删除发票
      deleteItem(item) {
        if (!this.$GFUN.powerIsInArray([162,282,378,612])) { this._alert('您没有相关权限！',null,'error'); return; }
        this._confirm('是否确认删除？',() => { this.deleteStoreInvoice(item.id) })
      },
      //添加发票
      addInvoice() {
        if (!this.$GFUN.powerIsInArray([163,279,376,611])) { this._alert('您没有相关权限！',null,'error'); return; }
        this.$router.push({name:'addInvoice',query:{store:this.$route.query.store,GST:this.$route.query.GST}})
      }
    },
  }
</script>
